import script from "./VehicleSelectWithAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleSelectWithAvatar.vue?vue&type=script&setup=true&lang=js"

import "./VehicleSelectWithAvatar.vue?vue&type=style&index=0&id=5ae03afe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae03afe"]])

export default __exports__